import { render, staticRenderFns } from "./ACodigoEstudiante.vue?vue&type=template&id=39038606"
import script from "./ACodigoEstudiante.vue?vue&type=script&lang=js"
export * from "./ACodigoEstudiante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports